import { render, staticRenderFns } from "./PublicPageModal.vue?vue&type=template&id=05f97bac&"
import script from "./PublicPageModal.vue?vue&type=script&lang=js&"
export * from "./PublicPageModal.vue?vue&type=script&lang=js&"
import style0 from "./PublicPageModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports